export const useAiChatWidget = () => {
  const bubbleState = ref('closed');


  const loadDrawer = ref(false);   // Handles internal lazy loading of the drawer, so that the drawer is not loaded until the user hovers over the bubble.
  // Handles internal lazy loading of the drawer, so that the drawer is not loaded until the user hovers over the bubble.
  const handleFirstHover = () => {
    loadDrawer.value = true;
  }

  const { $ld } = useNuxtApp();
  
  const getFeatureFlag = (flagName: string): boolean => {
    try {
      const ldClient = $ld as unknown as { flags?: Record<string, boolean> };
      return ldClient?.flags?.[flagName] ?? false;
    } catch {
      return false;
    }
  };

  const aiChatEnabled = computed(() => getFeatureFlag('cmsAiChat'));
  const aiContactFormEnabled = computed(() => getFeatureFlag('cmsContactForm'));

  const handleStateChange = (state: string) => {
    bubbleState.value = state;
  };

  const handleDrawerClose = () => {
    bubbleState.value = 'closed';
  }

  const isOpen = computed(() => {
    return bubbleState.value !== 'closed';
  });

  return {
    bubbleState,
    aiChatEnabled,
    aiContactFormEnabled,
    isOpen,
    loadDrawer,
    handleStateChange,
    handleDrawerClose,
    handleFirstHover
  };
};